import request from '@/utils/request';

//获取模板
export function indexFields(params) {
    return request({
        method: 'get',
        url: 'index/fields',
		params
    })
}

//文字创作
export function articleChat(data) {
    return request({
        method: 'post',
        url: 'article/chat',
		data:data
    })
}

//获取本次结果
export function articleGetHistory(params) {
    return request({
        method: 'get',
        url: 'article/getHistory',
		params
    })
}

//删除文本
export function articleDelete(params) {
    return request({
        method: 'get',
        url: 'article/delete',
		params
    })
}